export interface CronPartsState {
    iteratedMinutes: number | null;
    selectedMinutes: number[];
    selectedHours: number[];
    selectedDays: number[];
    selectedMonths: string[];
    selectedWeekDays: string[];
    frequency: string;
}

export const parseCronExpressionParts = (
    cron: string,
    months: string[],
    weekDays: string[]
): Partial<CronPartsState> | null => {
    const parts = cron.split(' ');
    if (parts.length !== 5) {
        return null;
    }

    const [minutePart, hourPart, dayPart, monthPart, weekDayPart] = parts;
    const state: Partial<CronPartsState> = {};

    if (minutePart?.includes('/')) {
        state.iteratedMinutes = Number(minutePart.replace(/[^0-9]/g, ''));
        state.selectedMinutes = [];
    } else {
        state.iteratedMinutes = null;
        state.selectedMinutes = minutePart === '*' ? [] : minutePart.split(',').map(Number);
    }

    state.selectedHours = hourPart === '*' ? [] : hourPart.split(',').map(Number);
    state.selectedDays = dayPart === '*' ? [] : dayPart.split(',').map(Number);
    state.selectedMonths =
        monthPart === '*' ? [] : monthPart.split(',').map((month) => months[parseInt(month, 10) - 1]);
    state.selectedWeekDays =
        weekDayPart === '*' ? [] : weekDayPart.split(',').map((day) => weekDays[parseInt(day, 10)]);

    if (monthPart !== '*' && dayPart !== '*') {
        state.frequency = 'Yearly';
    } else if (weekDayPart !== '*') {
        state.frequency = 'Weekly';
    } else if (dayPart !== '*') {
        state.frequency = 'Monthly';
    } else if (hourPart !== '*') {
        state.frequency = 'Daily';
    } else if (minutePart !== '*' && !minutePart?.includes('/')) {
        state.frequency = 'Hourly';
    } else {
        state.frequency = 'Minutely';
    }

    return state;
};
